import { render } from "./CallActionService.vue?vue&type=template&id=6a6e8cba&scoped=true"
import script from "./CallActionService.vue?vue&type=script&lang=js"
export * from "./CallActionService.vue?vue&type=script&lang=js"

import "./CallActionService.vue?vue&type=style&index=0&id=6a6e8cba&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a6e8cba"]])

export default __exports__